import { useCallback } from 'react';

import { di } from 'react-magnetic-di';
import {
	type MatchParams,
	generatePath as rrrGeneratePath,
	usePathParam,
} from 'react-resource-router-next';

import { getStudioPath } from '../../utils/get-studio-path';
import { isStudioV2 } from '../../utils/get-studio-version';

/**
 * This hook is only intended to be used in v1.
 * It's used as a helper for generating paths that's v2 compatible.
 */
export const useGeneratePath = (): (path: string, params?: MatchParams) => string => {
	di(usePathParam, isStudioV2);
	const [workspaceId] = usePathParam('workspaceId');
	const [spaceId] = usePathParam('spaceId');

	/**
	 * Given a v1 path, generate a v2 path if we are in v2.
	 */
	const generatePath = useCallback(
		(path: string, params?: MatchParams) => {
			return rrrGeneratePath(getStudioPath(path), {
				...params,
				...(isStudioV2() ? { workspaceId, spaceId } : {}),
			});
		},
		[spaceId, workspaceId],
	);

	return generatePath;
};
